<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Ordenes/Remitos</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model= "fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model= "fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    appMensaje: Mensaje
  },
  mixins: [
    msjModal,
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),

      labelCols: 2,
    }
  },
  created() {
  },  
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('compras/getRptOrdenesRemitos', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rpt = this.$store.getters['compras/rptCompras'];

            if (rpt) {
              if (rpt.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Ordenes-Remitos';
              let fileName = 'resumen-ordenes-remitos';
              let format = [
                { titulo: 'Tipo', nombre: 'documentoTipo', formato: '' },
                { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
                { titulo: 'Numero', nombre: 'numero', formato: '' },
                { titulo: 'Usuario', nombre: 'usuario', formato: '' },
                { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
                { titulo: 'Rubro', nombre: 'rubro', formato: '' },
                { titulo: 'Moneda', nombre: 'moneda', formato: '' },
                { titulo: 'Importe', nombre: 'importe', formato: '' },
                { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
                { titulo: 'Cliente', nombre: 'cliente', formato: '' },
                { titulo: 'Accion', nombre: 'accion', formato: '' },
                { titulo: 'Comp.Fecha', nombre: 'comprobanteFecha', formato: 'fecha' },
                { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
                { titulo: 'Comp.Numero', nombre: 'comprobanteNumero', formato: '' },
                { titulo: 'Neto Comp.', nombre: 'importeNetoComprobante', formato: '' },
                { titulo: 'Neto Facturado', nombre: 'importeNetoFacturado', formato: '' },
              ];

              this.exportXLS(title, fileName, rpt, format);

            } else {
              this.showModalMsj('No hay datos para exportar', null, null, 'light');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
  },
}
</script>

<style>
</style>
